<template>
  <div>
    <div
      class="component-wrapper secondary suggested-pois white d-flex flex-column align-center pa-4"
    >
      <div
        class="align-self-start d-flex flex-column align-start justify-center mb-4"
      >
        <div
          :style="main"
          class="primary rounded-pill px-2 d-flex align-center return-button mr-4 mb-2"
          @click="
            step == 1 || (step == 2 && subareas.length == 0)
              ? $router.push(`/islands/area/${$route.params.area_id}`)
              : (step = 1);
            pois = [];
            currentCategory = null;
          "
        >
          <v-btn icon>
            <v-icon color="white" size="17">mdi-arrow-left</v-icon>
          </v-btn>
          <span class="body-2 white--text pr-1">
            {{
              step == 1 || (step == 2 && subareas.length == 0)
                ? currentArea.name
                : $t("menu.areas")
            }}
          </span>
        </div>

        <v-chip
          @click:close="
            filterApply();
            currentCategory = null;
          "
          v-if="step == 2 && currentCategory != null"
          close
          close-icon="mdi-close"
          color="white"
          class="mt-2 primary--text"
        >
          {{ poiCategory(currentCategory.id).name }}
        </v-chip>
      </div>

      <div
        v-if="loader && step == 1"
        class="d-flex flex-column align-center justify-center flex-grow-1"
        style="height: 500px"
      >
        <v-progress-circular indeterminate color="white" size="60">
        </v-progress-circular>
      </div>

      <div v-if="loader && step == 2" style="width: 80%">
        <v-skeleton-loader
          v-for="(n, i) in 3"
          :key="i"
          v-bind="attrs"
          type="image,paragraph"
          :loading="loader"
        ></v-skeleton-loader>
      </div>

      <div
        v-if="step == 1 && !loader"
        class="d-flex flex-column"
        style="width: 100%"
      >
        <div class="white--text body-1 text-h6 mb-2">
          {{ $t("pois.step2") }}
        </div>
        <div v-for="(subarea, i) in subareas" :key="i + subarea.id">
          <v-btn
            class="white--text align-self-start body-1 py-8 d-flex justify-start"
            text
            @click="onSubareaSelect(subarea)"
            style="text-transform: none"
            width="100%"
          >
            <span>
              {{ subarea.name }}
            </span>
          </v-btn>
          <v-divider></v-divider>
        </div>
      </div>

      <div
        v-else-if="step == 2 && !loader"
        v-for="(poi, i) in pois"
        :key="i"
        class="d-flex flex-column"
        style="width: 100%"
      >
        <div
          v-if="poi.category_id != 23"
          @click="$router.push(`${$route.path}/${poi.id}/map`)"
          class="d-flex justify-center align-center route font-weight-thin body-1 mb-2 pb-4"
        >
          <v-card width="85vw" style="border-radius: 15px">
            <v-img
              width="100%"
              height="150px"
              v-if="poi.images.length != 0"
              :src="
                'https://api.e-naxios.com/images/' +
                poi.images[0].image[0].file_name
              "
            ></v-img>
            <div
              v-else
              style="width: 100%; height: 150px"
              class="d-flex align-center justify-center"
            >
              <v-icon size="100" color="secondary">
                mdi-image-off-outline
              </v-icon>
            </div>
            <div
              class="secondary--text body-2 font-weigth-regular category ml-6 pt-2"
              style="font-size: 12px"
            >
              {{ poiCategory(poi.category_id).name }}
            </div>
            <div class="secondary--text body-1 font-weight-bold ml-6 pb-2">
              {{ poi.name }}
            </div>
          </v-card>
        </div>
      </div>

      <div v-if="pois.length == 0 && step == 2" class="white--text">
        {{ $t("error_messages.no_pois") }}
      </div>
    </div>

    <v-bottom-sheet
      v-model="sheet"
      inset
      style="position: relative"
      scrollable
      v-if="step == 2"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          style="position: fixed; bottom: 80px; right: 30px"
          color="white"
          fab
          dark
          medium
        >
          <v-icon size="30" color="secondary" v-bind="attrs" v-on="on"
            >mdi-tune</v-icon
          >
        </v-btn>
      </template>

      <v-card color="white" height="auto" class="px-6 pb-16 mb-4">
        <div class="text-h5 font-weight-bold pt-6">
          {{ $t("general.categories_label") }}
        </div>
        <v-divider class="my-4"></v-divider>
        <div
          v-for="(category, i) in filteredCategories"
          :key="i + category.id"
          @click="filterApply(category)"
          class="mb-4"
        >
          <span
            :class="
              currentCategory && currentCategory.id == category.id
                ? 'font-weight-bold'
                : 'font-weight-regular'
            "
            class="body-1 d-flex align-center"
          >
            <span class="mr-auto">
              {{ category.name }}
            </span>
            <img
              v-if="currentCategory && currentCategory.id == category.id"
              class="check-icon"
              src="@/assets/icons/check.png"
            />
          </span>
        </div>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  async created() {
    try {
      const subareas = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subareas`
      );
      this.subareas = subareas.data;
      if (this.subareas.length == 0) {
        this.step = 2;
        const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
          params: {
            area: this.$route.params.area_id,
          },
        });
        this.initialPois = res.data;
        this.pois = res.data;
      } else {
        this.subareas.push({
          name: this.$t("general.all"),
          id: 999,
        });
      }

      this.loader = false;
    } catch (e) {
      throw e;
    }
  },

  data() {
    return {
      attrs: {
        class: "mb-6",
        // boilerplate: true,
        elevation: 2,
      },
      sheet: false,
      loader: true,
      initialPois: [],
      pois: [],
      step: 1,
      subareas: [],
      filters: {
        category: null,
      },
      currentCategory: null,
      subarea: null,
    };
  },

  computed: {
    ...mapState({
      currentArea: (state) => state.areas.currentArea,
      categories: (state) => state.pois.categories,
      insets: (state) => state.base.insets,
    }),
    main() {
      return {
        margin: `${this.insets?.top}px 0px 0px 0px`,
      };
    },

    filteredCategories() {
      const categoryIds = Array.from(
        new Set(this.initialPois.map((obj) => obj.category_id))
      );
      const matchingCategories = this.categories.filter((category) =>
        categoryIds.includes(category.id)
      );
      return matchingCategories;
    },
  },

  methods: {
    poiCategory(category_id) {
      return this.categories.find((el) => el.id == category_id);
    },

    async onSubareaSelect(subarea) {
      this.loader = true;

      if (subarea.id == 999) {
        const pois = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois`
        );
        this.step = 2;
        if (this.pois.length == 0) {
          this.initialPois = pois.data;
        }
        this.pois = pois.data;
        this.subarea = subarea;
        this.loader = false;

        return;
      }
      const res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
        params: {
          area: subarea.id,
        },
      });
      this.step = 2;
      if (this.pois.length == 0) {
        this.initialPois = res.data;
      }
      this.pois = res.data;
      this.subarea = subarea;
      this.loader = false;
    },

    async filterApply(category) {
      this.loader = true;
      this.currentCategory = category;

      this.sheet = false;
      let res = [];
      if (this.subarea?.id == 999 && this.subareas.length != 0) {
        if (category == undefined)
          res = await axios.get(
            `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois`
          );
        else {
          res = await axios.get(
            `${process.env.VUE_APP_BASE_URL}/areas/${this.$route.params.area_id}/subarea/pois/category/${category?.id}`
          );
        }
      } else {
        if (this.subarea == null) {
          res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
            params: {
              area: this.$route.params.area_id,
              category: category?.id,
            },
          });
        } else {
          res = await axios.get(`${process.env.VUE_APP_BASE_URL}/pois`, {
            params: {
              area: this.subarea?.id === 999 ? null : this.subarea?.id,
              category: category?.id,
            },
          });
        }
      }

      if (this.subarea?.id == 999 && this.subareas.length != 0) {
        this.pois = res.data.filter((poi) =>
          this.subareas.some((area) => area.id === poi.area_id)
        );
      } else {
        this.pois = res.data;
      }
      this.loader = false;
    },
  },
};
</script>

<style scoped lang="scss">
.suggested-pois {
  top: 0px;
  height: 100%;
  width: 100vw;
  position: absolute;
  // flex: 1 1 1px; /* new */
  overflow-y: auto !important;
}

.user-routes {
  top: 50vh; //suggested-routes height
  width: 100vw;
  height: calc(100% - 50vh);
  position: absolute;
  overflow-y: auto !important;
}

.route {
  width: 100%;
}

.category::before {
  content: "";
  position: absolute;
  left: 0;
  margin-top: 8px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;

  width: 12px;
  height: 5px;
  background: var(--v-accent-base);
}

.check-icon {
  width: 19px;
  height: 14px;
}
</style>
